export default class InMemoryStateStore {
    constructor() {
        this._store = {}
    }

    set(key, value) {
        this._store[key] = value
        return Promise.resolve()
    }

    get(key) {
        return Promise.resolve(this._store[key])
    }

    remove(key) {
        delete this._store[key]
        return Promise.resolve()
    }

    getAllKeys() {
        return Promise.resolve(Object.keys(this._store))
    }
}
